"use client";

import * as React from 'react';
import { cn } from '../lib/utils';
import { useFieldControl } from '../lib/field';

export interface SwitchProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className, checked, onCheckedChange, onClick, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? 'checked' : 'unchecked'}
      onClick={(event) => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          onCheckedChange?.(!checked);
        }
      }}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border border-transparent p-0.5',
        'transition-colors duration-[var(--duration-base)]',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-accent hover:bg-accent-hover' : 'bg-input hover:bg-muted-foreground',
        className
      )}
      {...useFieldControl(props, { required: false })}
    >
      <span
        className={cn(
          'pointer-events-none block size-4 rounded-full bg-white shadow-sm transition-transform duration-[var(--duration-base)] ease-[var(--ease-standard)]',
          checked ? 'translate-x-4' : 'translate-x-0'
        )}
      />
    </button>
  )
);

Switch.displayName = 'Switch';
